import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=306826c8&scoped=true&"
import script from "./IconDelete.vue?vue&type=script&lang=js&"
export * from "./IconDelete.vue?vue&type=script&lang=js&"
import style0 from "./IconDelete.vue?vue&type=style&index=0&id=306826c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306826c8",
  null
  
)

export default component.exports